import { createBrowserRouter } from 'react-router';

import { App } from './App';
import { Accueil } from './ecrans/Accueil';
import { Invitation } from './ecrans/Invitation';

// L'écran d'accueil et le lien d'invitation sont dans le paquet principal (ouverture
// depuis une notification) ; le reste est chargé à la demande.
export const router = createBrowserRouter([
  {
    path: '/',
    Component: App,
    children: [
      { index: true, Component: Accueil },
      { path: 'i', Component: Invitation },
      {
        path: 'reglages',
        lazy: async () => ({ Component: (await import('./routes/secondaires')).Reglages }),
      },
      {
        path: 'messages',
        lazy: async () => ({ Component: (await import('./routes/secondaires')).Messages }),
      },
      {
        path: 'historique',
        lazy: async () => ({ Component: (await import('./routes/secondaires')).Historique }),
      },
      {
        path: 'donnees',
        lazy: async () => ({ Component: (await import('./routes/secondaires')).Donnees }),
      },
      {
        path: 'oubli',
        lazy: async () => ({ Component: (await import('./routes/secondaires')).Oubli }),
      },
      {
        path: 'confidentialite',
        lazy: async () => ({ Component: (await import('./routes/legales')).Confidentialite }),
      },
      {
        path: 'mentions-legales',
        lazy: async () => ({ Component: (await import('./routes/legales')).Mentions }),
      },
      {
        path: '*',
        lazy: async () => ({ Component: (await import('./routes/NotFound')).NotFound }),
      },
    ],
  },
]);
